import request from '@/utils/request'

let DiyformApi = {

  /*DIY表单管理列表*/
  list(data) {
    return request._post('/shop/plus.diyform.Index/index', data);
},
/*添加DIY表单管理*/
add(data) {
    return request._post('/shop/plus.diyform.Index/add', data);
},
/*修改DIY表单管理*/
edit(data) {
    return request._post('/shop/plus.diyform.Index/edit', data);
},
/*删除DIY表单管理*/
del(data) {
    return request._post('/shop/plus.diyform.Index/del', data);
},
/*DIY表单管理详情*/
detail(data) {
  return request._post('/shop/plus.diyform.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.diyform.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.diyform.Setting/getSetting', data, errorback);
    },
}
export default DiyformApi;



// WEBPACK FOOTER //
// ./src/api/diyform.js